import { Ref, forwardRef } from "react"
import { Form, FormikProps } from "formik"
import { Formik } from "../../../../../shared/components/forms/SchemaFormik"
import { EditFeatureFormContent } from "./EditFeatureFormContent"
import * as yup from "yup"
import { EditFeatureFormValues, FeatureStatus, UserPlan } from "../featuresTypes"
import { useAppLocalization } from "../../../../localization/components/AppLocalizationProvider"

type EditFeatureFormProps = Readonly<{
    initialValues?: EditFeatureFormValues | null
    onSubmit: (formData: EditFeatureFormValues) => void
}>
type FormikRef = Ref<FormikProps<EditFeatureFormValues>>

export const EditFeatureForm = forwardRef(({ initialValues, onSubmit }: EditFeatureFormProps, ref: FormikRef) => {
    const { l10n } = useAppLocalization()

    const defaultInitialValues: EditFeatureFormValues = {
        progId: "",
        name: "",
        plan: UserPlan.NONE,
        status: FeatureStatus.NEW,
        isEnabled: false,
    }

    const validationSchema = yup.object({
        name: yup.string().required(l10n.getString("required-field")),
        plan: yup.string().required(l10n.getString("required-field")),
        status: yup.string().required(l10n.getString("required-field")),
        isEnabled: yup.boolean(),
    })

    function handleSubmit(values: EditFeatureFormValues) {
        onSubmit(values)
    }

    return (
        <Formik<EditFeatureFormValues>
            enableReinitialize
            initialValues={initialValues ? initialValues : defaultInitialValues}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            innerRef={ref}
        >
            <Form>
                <EditFeatureFormContent />
            </Form>
        </Formik>
    )
})
